<template>
  <div>
    <div class="input-group">
      <input
        v-model="searchText"
        v-debounce="searchForItems"
        type="text"
        class="form-control et-gf-search"
        placeholder="Search"
      >
      <span class="input-group-btn">
        <button
          class="btn btn-search rounded-0"
          type="button"
        />
      </span>
    </div>
    <span
      v-if="loadingSearch"
      class="image_loading_search"
    >
      <img
        src="https://www.gofundraise.com.au/Content/images/loader-orange.gif"
        alt=""
      >
    </span>
    <div
      v-if="valueEnterSearch"
      v-click-outside="clickedOutside"
      class="search_result"
    >
      <ul class="list-unstyled mb-0">
        <li
          v-for="(item, index) in beneficiaryAutoCompleteList"
          :key="index"
          @click="itemSelected(item)"
        >
          {{ item.BeneficiaryName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
    directives: {
        ClickOutside,
    },
    props: {
        beneficiaryAutoCompleteList: {
            type: Array,
            default: () => []
        },
        loadingSearch: {
            type: Boolean,
            default: false
        },
        valueEnterSearch: {
            type: Boolean,
            default: false
        },
        textValue: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            searchText: ''
        }
    },

    watch: {
        textValue(val) {
            this.searchText = val;
        }
    },

    methods: {
        clickedOutside() {
            this.$emit('clickedOutside')
        },
        itemSelected(item) {
            this.$emit('itemSelected', item)
        },
        searchForItems() {
          if (!this.searchText || this.searchText === "") {            
            this.$emit('textChanged', "")            
          }

          this.$emit('textChanged', this.searchText);
        }
    }
};
</script>
<style scoped>
.search_result {
	background-color: #f6f6f6;
	position: absolute;
	z-index: 10;
	width: 95%;
}
.search_result ul {
	margin-bottom: 0;
}
.search_result li {
	padding: 10px;
	color: #666363;
	border-bottom: 1px solid #ddd;
	cursor: pointer;
}

@media (hover: hover) {
	.search_result li:hover {
		background-color: #c1c1c1;
		color: #fff;
	}
}
.image_loading_search {
	position: absolute;
	right: 4%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
}
.image_loading_search img {
	width: 60%;
}
</style>
